import React from "react";
import "./ReferralCard.css";
import { Util } from "./../../../../../helpers/util";

const ReferralCard = ({ data }) => {
  const { currency } = Util.getCurrency();
  return (
    <div className="referral">
      <div className="referral-card">
        <div className="card-one">
          <p>Interest Rate</p>
          <h6 style={{ color: "#038830" }}>
            {currency} {Util.formatMoneyNumber(data.pendingEarnings)}
          </h6>
        </div>
        <div className="card-one">
          <p>Pending Earnings</p>
          <h6 style={{ color: "#FD740E" }}>
            {currency} {Util.formatMoneyNumber(data.pendingEarnings)}
          </h6>
        </div>
        <div className="card-one">
          <p>Members Referred</p>
          <h6 style={{ color: "#0768F6" }}>{data.membersReferred}</h6>
        </div>
      </div>
    </div>
  );
};

export default ReferralCard;
